module.exports = __webpack_public_path__ + "static/img/slider-4.97d582f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/slider-4.jpg
// module id = 5LSe
// module chunks = 7